import Screen from '../../js/lib/screen';
const dropdownTrigger = document.querySelectorAll('.js-dropdown-trigger');
const dropdownMenu= document.querySelectorAll('.js-dropdown');
const screen = new Screen();

const toggleDropdown = (event) => {
  const elementToOpen = event.currentTarget.parentElement;
  if (elementToOpen.dataset.open === "true") {
    // closeDropdown()
    elementToOpen.removeAttribute('data-open');
    elementToOpen.blur();
  } else {
    // closeDropdown()
    elementToOpen.setAttribute('data-open', true);
    elementToOpen.focus();
  }
}
const closeDropdown = () => {
  for (var i = 0; i < dropdownMenu.length; i++) {
    dropdownMenu[i].removeAttribute('data-open')
  }
}
if (dropdownTrigger) {
  for (var i = 0; i < dropdownTrigger.length; i++) {
    dropdownTrigger[i].addEventListener('click', (event) => {
      toggleDropdown(event)
    });
  }
}



// WEBPACK FOOTER //
// ./modules/dropdown.js